var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{attrs:{"controls":"","width":_vm.width,"height":_vm.srcData[_vm.id].realHeight}},[_c('source',{attrs:{"src":_vm.srcData[_vm.id].link,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }